export var MuiInputBase = {
  styleOverrides: {
    root: function root(_ref) {
      var theme = _ref.theme;
      return {
        borderRadius: "".concat(theme.button.borderRadius, "px !important"),
        "& input": {
          paddingLeft: theme.spacing(theme.spaces.main),
          paddingRight: theme.spacing(theme.spaces.main)
        }
      };
    }
  }
};
//# sourceMappingURL=MuiInputBase.js.map